module.exports = __webpack_public_path__ + "static/media/telos.f34c7343.jpg";